<template>
  <div>
    <top-agent-self-agent-monthly-bill v-if="this.$store.getters.userRole === 'top_agent'" />
    <merchant-self-agent-monthly-bill v-else-if="this.$store.getters.userRole === 'merchant'" />
  </div>
</template>

<script>

export default {
  name: 'ShowAgentMonthlyBill',
  components: {
    TopAgentSelfAgentMonthlyBill: () => import('@/views/agent_monthly_bills_commission/top_agent_self/Show'),
    MerchantSelfAgentMonthlyBill: () => import('@/views/agent_monthly_bills_commission/merchant_self/Show')
  }
}
</script>
